export default __webpack_public_path__ + "static/media/check_mark.cb42adfa.svg";